<template>
<div>
  <div @click="display=true" class="survey-question small-top">{{question.question}}</div>
  <question-modal 
    :question="question" 
    v-if="display"
    :dimensions="dimensions"
    @delete="destroy"
    @save="save"
    @close="display=false"
    :editable="editable"
    />
</div>
</template>

<script>
import snackbarHub from "@/services/hubs/snackbar";
import questionModal from "./questionModal";

export default {
  components: {
    questionModal
  },
  props: ["question", "dimensions", "editable"],
  data() {
    return {
      saving: false,
      display: false
    };
  },
  methods: {
    destroy() {
      this.saving = true;
      this.question
        .destroy()
        .then(() => {
          snackbarHub.update("Deleted");
          this.$emit("deleted", this.question.id);
        })
        .then(() => {
          this.saving = false;
          this.display = false;
        });
    },
    save() {
      this.question.save().then(() => {
        this.display = false;
        snackbarHub.update("Saved");
      });
    }
  }
};
</script>

<style>
</style>
